import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSetPageTitle } from '../../hooks/useSetPageTitle';
import { AppLayout } from '../../components/layout/app-layout';
import {
  OPERATIONS_DEFAULT_TAB,
  OPERATIONS_SIDEBAR,
  OPERATIONS_TAB_IDS,
  OPERATIONS_TABS,
} from '../../components/layout/operations-nav.config';
import { useGetSchedulerFailuresQuery } from '../../redux/operations/operations.endpoints';
import EtlDashboardTab from './tabs/etl-dashboard.tab';
import SchedulerDashboardTab from './tabs/scheduler-dashboard.tab';

const OperationsPage = () => {
  useSetPageTitle('Operations');
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  const { data: schedulerFailures } = useGetSchedulerFailuresQuery(undefined, {
    pollingInterval: 120_000,
  });
  const failureCount = schedulerFailures?.failure_count ?? 0;

  const operationsTabs = useMemo(
    () =>
      OPERATIONS_TABS.map((operationsTab) =>
        operationsTab.id === 'scheduler' && failureCount > 0
          ? { ...operationsTab, badge: failureCount }
          : operationsTab,
      ),
    [failureCount],
  );

  const currentTab = OPERATIONS_TAB_IDS.includes(tab ?? '')
    ? (tab as string)
    : OPERATIONS_DEFAULT_TAB;

  useEffect(() => {
    if (!tab || !OPERATIONS_TAB_IDS.includes(tab)) {
      navigate(`/operations/${OPERATIONS_DEFAULT_TAB}`, { replace: true });
    }
  }, [navigate, tab]);

  const handleTabChange = (tabId: string) => {
    navigate(`/operations/${tabId}`);
  };

  return (
    <AppLayout
      activePage={OPERATIONS_SIDEBAR.path}
      navbarProps={{
        tabs: operationsTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {currentTab === 'etl' && <EtlDashboardTab />}
        {currentTab === 'scheduler' && <SchedulerDashboardTab />}
      </div>
    </AppLayout>
  );
};

export default OperationsPage;
